import { render } from "./SettingsLayout.vue?vue&type=template&id=34cf2fb2&scoped=true"
import script from "./SettingsLayout.vue?vue&type=script&lang=js"
export * from "./SettingsLayout.vue?vue&type=script&lang=js"

import "./SettingsLayout.vue?vue&type=style&index=0&id=34cf2fb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34cf2fb2"]])

export default __exports__